module.exports = __webpack_public_path__ + "img/cmi.e7c711a0.png";